import React from "react";
import { useTranslation } from "react-i18next";
import { Crown, ShieldCheck, UserCog, Eye, Camera } from "lucide-react";

/**
 * Badge du role WORKSPACE (owner/admin/member/viewer/capture).
 *
 * A ne pas confondre avec `users.role`, qui ne vaut que "user" ou "admin" et
 * n'est qu'un drapeau superutilisateur plateforme.
 *
 * Extrait de Workspaces.jsx pour etre partage avec Reglages -> Profil.
 * `capture` (role mobile non hierarchique) a ete ajoute a l'extraction :
 * sans lui, un utilisateur capture retombait sur le defaut `viewer` et
 * voyait un role faux.
 */
export default function RoleBadge({ role }) {
  const { t } = useTranslation("workspaces");
  const ROLE_META = {
    owner:   { label: t("roles.owner"),   Icon: Crown,       tone: "bg-amber-50 text-amber-800 border-amber-200" },
    admin:   { label: t("roles.admin"),   Icon: ShieldCheck, tone: "bg-indigo-50 text-indigo-800 border-indigo-200" },
    member:  { label: t("roles.member"),  Icon: UserCog,     tone: "bg-emerald-50 text-emerald-800 border-emerald-200" },
    viewer:  { label: t("roles.viewer"),  Icon: Eye,         tone: "bg-zinc-50 text-zinc-700 border-zinc-200" },
    capture: { label: t("roles.capture"), Icon: Camera,      tone: "bg-sky-50 text-sky-800 border-sky-200" },
  };
  const meta = ROLE_META[role] || ROLE_META.viewer;
  const Icon = meta.Icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-xs font-medium ${meta.tone}`}
      data-testid={`role-badge-${role}`}
    >
      <Icon size={12} strokeWidth={2} />
      {meta.label}
    </span>
  );
}
